import { Accept } from "react-dropzone";

export interface FileExtension {
  name: string;
  mimeTypes: string[];
}

export const IMAGES_EXTENSIONS: FileExtension[] = [
  {
    name: ".jpg",
    mimeTypes: ["image/jpeg"],
  },
  {
    name: ".jpeg",
    mimeTypes: ["image/jpeg"],
  },
  {
    name: ".jfif",
    mimeTypes: ["image/jpeg"],
  },
  {
    name: ".png",
    mimeTypes: ["image/png"],
  },
];

export const CVS_EXTENSIONS: FileExtension[] = [
  {
    name: ".pdf",
    mimeTypes: ["application/pdf"],
  },
  {
    name: ".doc",
    mimeTypes: ["application/msword"],
  },
  {
    name: ".docx",
    mimeTypes: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  },
];

export const ATTACHMENTS_EXTENSIONS: FileExtension[] = [
  {
    name: ".pdf",
    mimeTypes: ["application/pdf"],
  },
  {
    name: ".doc",
    mimeTypes: ["application/msword"],
  },
  {
    name: ".docx",
    mimeTypes: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  },
  {
    name: ".ppt",
    mimeTypes: ["application/vnd.ms-powerpoint"],
  },
  {
    name: ".pptx",
    mimeTypes: ["application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  },
  {
    name: ".xls",
    mimeTypes: ["application/vnd.ms-excel"],
  },
  {
    name: ".xlsx",
    mimeTypes: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  },
  {
    name: ".odt",
    mimeTypes: ["application/vnd.oasis.opendocument.text"],
  },
  {
    name: ".odp",
    mimeTypes: ["application/vnd.oasis.opendocument.presentation"],
  },
  {
    name: ".ods",
    mimeTypes: ["application/vnd.oasis.opendocument.spreadsheet"],
  },
  {
    name: ".jpg",
    mimeTypes: ["image/jpeg"],
  },
  {
    name: ".jpeg",
    mimeTypes: ["image/jpeg"],
  },
  {
    name: ".png",
    mimeTypes: ["image/png"],
  },
  {
    name: ".dwg",
    mimeTypes: ["application/acad", "image/x-dwg", "image/vnd.dwg"],
  },
];

export const buildInputAccept = (extensions: FileExtension[]): string => {
  return extensions.map(e => e.name).join(", ");
};

export const buildDropzoneAccept = (extensions: FileExtension[]): Accept => {
  const result: Accept = {};

  for (const { name, mimeTypes } of extensions) {
    for (const mimeType of mimeTypes) {
      if (result[mimeType]) {
        result[mimeType].push(name);
      } else {
        result[mimeType] = [name];
      }
    }
  }

  return result;
};
